<mat-toolbar
    *ngIf="
        router.url !== '/auth/signin' && router.url !== '/auth/signup';
        else blank
    "
    class="toolbarNav"
>
    <span
        routerLink="/home"
        class="itemToolbar"
        matRipple
        [ngClass]="{ 'active-tab': currentTab === '/home' }"
    >
        <img class="icons" src="assets/icons/accueil icon.svg" alt="" />
        <span class="iconText">{{ "FOOTER.HOME" | translate }}</span>
    </span>
    <span
        routerLink="/account"
        [ngClass]="{ 'active-tab': currentTab === '/account' }"
        class="itemToolbar"
        matRipple
    >
        <mat-icon
            style="color: #777777"
            class="material-icons color_blue icons"
        >
            person_outline</mat-icon
        >
        <span class="iconText">{{ "FOOTER.USER" | translate }}</span>
    </span>
    <span
        [ngClass]="{ 'active-tab': currentTab === '/notification' }"
        class="itemToolbar"
        matRipple
        routerLink="/notification"
    ><div style="
    position: relative; text-align: center;    display: flex;
    flex-direction: column;
    align-items: center;">
        <mat-icon
            style="color: #777777"
            class="material-icons color_blue icons"
        >
            notifications_none</mat-icon
        >
        <span class="iconText">{{ "FOOTER.NOTIF" | translate }}</span>
        <div class="notification-dot" *ngIf="notificationDot">
            {{newNotificationCount}}
        </div>        
    </div>

    </span>
</mat-toolbar>
<ng-template #blank></ng-template>
